<template>
  <div v-show="parentContainer.pageCount > 1" class="carousel-pagination">
    <ul class="carousel-dot-container">
      <li
        v-for="(page, index) in parentContainer.pageCount"
        :key="index"
        class="carousel-dot"
        :class="getClass(index, parentContainer.currentPage)"
        @click="parentContainer.goToPage(index, 'pagination')"
      >
        <button
          class="carousel-dot-inner"
          :style="index == parentContainer.currentPage ? 'border: 2px solid #979797;' : ''"
          :title="`Go to slide ${index}`"
          :aria-label="`ariaLabel ${index}`"
        ></button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'quick-link-pagination',
  props: {
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return { parentContainer: this.$parent };
  },
  methods: {
    getClass(index, currentPage) {
      if (currentPage === 0) {
        return {
          'carousel-orange': index === currentPage,
          'carousel-black': index === 1 && !currentPage,
          'carousel-white': index === 2 && currentPage === 0,
        };
      } else if (currentPage === 1) {
        return {
          'carousel-orange': index === currentPage,
          'carousel-black': index === 0 && currentPage === 1,
          'carousel-white': index === 2 && currentPage === 1,
        };
      } else {
        return {
          'carousel-orange': index === 1 && currentPage === 2,
          'carousel-black': index === 2 && currentPage === 2,
          'carousel-white': index === 0 && currentPage === 2,
        };
      }
    },
  },
};
</script>
